jQuery(document).ready(function($) {

    const ics = require('ics');

    //Check if ics exists
    if (typeof ics === 'undefined') {
        console.error('ics.js is not loaded. Make sure it is enqueued properly.');
        return; // Exit if ics.js is not available
    }

    // Attach event listener to the container, delegating to the button
    $('.mad-events').on('click', '.mad-events__button--ics-download', function(e) {
        e.preventDefault();

        // Find the parent event item
        const item = $(this).closest('.mad-events__event-container')[0];

        if (!item) {
            console.error('Could not find the parent .mad-events__event-container');
            return;
        }

        const title = item.getAttribute('data-title') || '';
        const start = item.getAttribute('data-start') || '';
        const end = item.getAttribute('data-end') || '';
        const location = item.getAttribute('data-location') || '';
        const description = item.getAttribute('data-description') || '';

        const startDate = new Date(start);
        const endDate = new Date(end);

        // Create an array required by the ics library: [year, month, day, hour, minute]
        const startArr = [
            startDate.getFullYear(),
            startDate.getMonth() + 1,
            startDate.getDate(),
            startDate.getHours(),
            startDate.getMinutes()
        ];

        // Calculate duration in minutes.  If end is before start, default to zero
        let durationMinutes = Math.max(0, Math.floor((endDate - startDate) / 60000));


        const eventObj = {
            title,
            start: startArr,
            duration: { minutes: durationMinutes },
            location: location || undefined,
            description: description || undefined // Use the description
        };

        ics.createEvent(eventObj, (error, value) => {
            if (error) {
                console.error(error);
                return;
            }

            // Trigger the download of the generated ICS file
            const filename = `${title || 'event'}.ics`;
            const blob = new Blob([value], { type: 'text/calendar' });
            const url = URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = filename;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            URL.revokeObjectURL(url);
        });
    });

    // Google Calendar button click handler (example - implement the URL generation from previous examples)
    $('.mad-events').on('click', '.mad-events__button--google-calendar', function(e) {
        e.preventDefault();
        const item = $(this).closest('.mad-events__event-container')[0];
        const title = item.getAttribute('data-title') || '';
        const start = item.getAttribute('data-start') || '';
        const end = item.getAttribute('data-end') || '';
        const location = item.getAttribute('data-location') || '';
        const description = item.getAttribute('data-description') || '';

        // Format dates for Google Calendar: YYYYMMDDTHHmmssZ (UTC)
        // Adjust this function if your dates are not in UTC
        const formatDateForGCal = (dateStr) => {
            const d = new Date(dateStr);
            // Convert to ISO string and remove unwanted characters.
            return d.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
        };

        const startFormatted = formatDateForGCal(start);
        const endFormatted = formatDateForGCal(end);

        let url = 'https://calendar.google.com/calendar/r/eventedit?';
        url += 'text=' + encodeURIComponent(title);
        url += '&dates=' + startFormatted + '/' + endFormatted;
        if (location) {
            url += '&location=' + encodeURIComponent(location);
        }

        window.open(url, '_blank');
    });
});